import { X } from "@phosphor-icons/react";

export default function Modal({ open, onClose, title, children, testId }) {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40 backdrop-blur-sm"
      onClick={onClose}
      data-testid={testId ? `${testId}-backdrop` : "modal-backdrop"}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="brutal-card w-full max-w-md max-h-[90vh] overflow-y-auto p-6 relative"
        data-testid={testId || "modal"}
      >
        <button
          onClick={onClose}
          className="absolute top-3 right-3 w-8 h-8 rounded-full border-2 border-black bg-white hover:bg-red-200 flex items-center justify-center"
          data-testid="modal-close-btn"
        >
          <X size={16} weight="bold" />
        </button>
        <h2 className="font-outfit font-black text-2xl mb-4 pr-8">{title}</h2>
        {children}
      </div>
    </div>
  );
}
